import React from 'react';

export default function FwLocationIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-map-marker-alt' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
